import { service_translate_generations } from '@/services/translate/SERVICE__translate_generations';
import { LOCAL__generation_upsert_generation } from '@/state/generation/entity/LOCAL__generation_upsert_generation';
import { store } from '@/state/store';
import { FN_UI__try_update_generation_layout_image_edit } from '@/state/ui/_methods/FN_UI__try_update_generation_layout_image_edit';
import { FN_WORDS__init_in_tokens_generation } from '@/state/words/_methods/FN_WORDS__init_in_tokens_generation';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { FN_GRID2D__init_possible_features } from '../../_methods/FN_GRID2D__init_possible_features';
import { FN_IMAGE_ASSET__add_to_generation_single } from '../image/_methods/FN_IMAGE_ASSET__add_to_generation_single';
import { FN_IMAGE_ASSET__update_generation_layout_image_edit } from '../image/_methods/FN_IMAGE_ASSET__update_generation_layout_image_edit';

export function HANDLER_CLIENT__generations_upsert(items: any) {
  assert_array_instanceof(items, DTO__generation);

  let images_map = store.getState().slice_images.images_map;

  for (let generation of items) {
    let fields_map = generation.tool.graph.fields__get_map();

    FN_IMAGE_ASSET__add_to_generation_single(generation, images_map);

    FN_UI__try_update_generation_layout_image_edit(generation, fields_map);
  }

  FN_IMAGE_ASSET__update_generation_layout_image_edit(images_map);

  FN_GRID2D__init_possible_features(items);
  FN_WORDS__init_in_tokens_generation(items);

  service_translate_generations.on_generations_received(items);

  store.dispatch(LOCAL__generation_upsert_generation(items));
}
